import React from 'react'
import {Col, Container, Row} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import './Footer.css'

const Footer = () => (
   <div className="Footer">
        <footer>
            <Container id={"footer"}>
                {/*<div className="footerContent" className={"content"}>*/}
                    <Container id="homeJumbotronGrid">
                        <Row className="show-grid">
                            <Col>
                                <Container className={"footerContent"}>
                                    <Row>
                                        <Col xs={12} s={12} md={12} lg={3} xl={3}>
                                            <span className={"footerLogo"}>ögonremiss.se</span>
                                        </Col>
                                        <Col xs={12} s={12} md={12} lg={4} xl={4}>
                                            <span className={"footerLinks"}><Link to="/info#omoss">Om oss</Link> • <Link to="/info#kontakt">Kontakt</Link> • <Link to="/integritetspolicy">Integritetspolicy</Link></span>
                                        </Col>
                                        <Col xs={12} s={12} md={12} lg={5} xl={5}>
                                            <span className={"footerCopyright"}>© 2018 Bluebrick AB | Org.nr: 556687-7428</span>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                        </Row>
                    </Container>
                {/*</div>*/}
            </Container>
        </footer>
   </div>
)

export default Footer